import comp from "./FeedsContainer";
export default comp;
